export default __webpack_public_path__ + "adf14325422b8d3aaa03e517c7fc9384.png";